import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API, environment } from '@core/envs';
import { IDealerByLocation, IResponseModel } from '@core/interface';
import { catchError, firstValueFrom, Observable, tap } from 'rxjs';
import { DealerHelperService } from './dealer-helper.service';
import { VehicleService } from '../vehicle/vehicle.service';

@Injectable({
  providedIn: 'root',
})
export class PreferredDealerService extends DealerHelperService {
  readonly #http = inject(HttpClient);
  // private readonly vehicleService = inject(VehicleService);

  // update preferred dealer endpoint/signal
  async updatePreferredDealerByVin(
    vin: string,
    dealer: IDealerByLocation | null,
  ) {
    const api = environment.getRoute(API.users);
    const url = `${api}/vehicles/${vin}?region=SA`;

    const body = {
      preferredDealer: dealer?.dealerId ?? '',
    };

    this.preferredDealer.set({
      dealer: null,
      loading: true,
      error: false
    });

    await firstValueFrom(
      this.#http.put<IResponseModel<null>>(url, body).pipe(
        tap(() => {
          let formattedDealer = dealer ? this.formatDealerServiceHours(dealer) : null;
          
          if (formattedDealer) {
            formattedDealer = this.setDealerSpecialistFlags(formattedDealer);
          }
          
          this.preferredDealer.set({
            dealer: formattedDealer,
            loading: false,
            error: false
          })
        }),
        catchError(() => {
          this.preferredDealer.set({
            dealer: null,
            loading: false,
            error: true
          })
          return new Observable<null>();
        })
      )
    );
  }

  fetchDealerDetails(
    dealerId: string,
    country: string,
    modelGroup = ''
  ) {
    const api = environment.getRoute(API.dealer);
    const url = `${api}/dealers/${dealerId}?country=${country}&modelGroup=${modelGroup}`;

    this.preferredDealer.set({
      dealer: null,
      loading: true,
      error: false
    });

    firstValueFrom(
      this.#http.get<IResponseModel<IDealerByLocation>>(url).pipe(
        tap((data) => {
          let formattedDealer = this.formatDealerServiceHours(data.response);
          
          formattedDealer = this.setDealerSpecialistFlags(formattedDealer);

          this.preferredDealer.set({
            dealer: formattedDealer,
            loading: false,
            error: false
          });
        }),
        catchError(() => {
          this.preferredDealer.set({
            dealer: null,
            loading: false,
            error: true
          });
          return new Observable<null>();
        })
      )
    );
  }
}
